import { useRef } from 'react';
import LocalizedStrings from 'react-localization';

type TranslationsType = {
  [key in 'sv' & 'en']: {
    [key: string]: string;
  };
};

export default function useLocalizedStrings<T extends TranslationsType>(
  translationData: T,
  lang: string,
) {
  const translations = useRef(new LocalizedStrings<T>(translationData));

  translations.current.setLanguage(lang);
  return translations.current;
}
